export enum LIABILITY_TYPE {
  CAR_LOAN = 'CAR_LOAN',
  HOME_LOAN = 'HOME_LOAN',
  CREDIT_CARD = 'CREDIT_CARD',
  STORE_CARD = 'STORE_CARD',
  PERSONAL_LOAN = 'PERSONAL_LOAN',
  SHORT_TERM_FINANCE = 'SHORT_TERM_FINANCE',
  LEASE = 'LEASE',
  HIRE_PURCHASE = 'HIRE_PURCHASE',
  TAX_DEBT = 'TAX_DEBT',
  LINE_OF_CREDIT = 'LINE_OF_CREDIT',
  OVERDRAFT = 'OVERDRAFT',
  HELP_HECS_DEBT = 'HELP_HECS_DEBT',
  OTHER = 'OTHER',
}

export enum LOAN_OPTION {
  NONE = 'NONE',
  INCREASE = 'INCREASE',
  CONSOLIDATE = 'CONSOLIDATE',
  CLEAR_FROM_OTHER_SOURCE = 'CLEAR_FROM_OTHER_SOURCE',
}

export enum LIABILITIES_CLEARING_FROM_OTHER_SOURCE {
  PAYING_OUT = 'PAYING_OUT',
  REDUCING = 'REDUCING',
}

export const LIABILITIES_WITH_NEW_LIMIT = [
  LIABILITY_TYPE.CREDIT_CARD,
  LIABILITY_TYPE.STORE_CARD,
  LIABILITY_TYPE.LINE_OF_CREDIT,
  LIABILITY_TYPE.OVERDRAFT,
  LIABILITY_TYPE.OTHER,
];

export const LIABILITY_FIELDS_STATES = {
  CATEGORIES: {
    HIDDEN: [LIABILITY_TYPE.HOME_LOAN, LIABILITY_TYPE.CAR_LOAN],
  },
  OWNERSHIP: {
    SINGLE: [
      LIABILITY_TYPE.CREDIT_CARD,
      LIABILITY_TYPE.STORE_CARD,
      LIABILITY_TYPE.TAX_DEBT,
      LIABILITY_TYPE.HELP_HECS_DEBT,
    ],
  },
  LENDER: {
    DISABLED: [LIABILITY_TYPE.TAX_DEBT, LIABILITY_TYPE.HELP_HECS_DEBT],
  },
  CREDIT_LIMIT: {
    DISABLED: [LIABILITY_TYPE.CAR_LOAN, LIABILITY_TYPE.TAX_DEBT, LIABILITY_TYPE.HELP_HECS_DEBT],
    OPTIONAL: [LIABILITY_TYPE.OTHER],
    HIDDEN: [LIABILITY_TYPE.TAX_DEBT, LIABILITY_TYPE.HELP_HECS_DEBT],
  },
  RATE: {
    ENABLED: [
      LIABILITY_TYPE.CAR_LOAN,
      LIABILITY_TYPE.CREDIT_CARD,
      LIABILITY_TYPE.HOME_LOAN,
      LIABILITY_TYPE.LINE_OF_CREDIT,
      LIABILITY_TYPE.OTHER,
      LIABILITY_TYPE.OVERDRAFT,
      LIABILITY_TYPE.PERSONAL_LOAN,
      LIABILITY_TYPE.STORE_CARD,
    ],
    OPTIONAL: [LIABILITY_TYPE.OTHER],
    HIDDEN: [
      LIABILITY_TYPE.HIRE_PURCHASE,
      LIABILITY_TYPE.LEASE,
      LIABILITY_TYPE.TAX_DEBT,
      LIABILITY_TYPE.HELP_HECS_DEBT,
    ],
  },
  REPAYMENTS_AMOUNT: {
    DISABLED: [LIABILITY_TYPE.CREDIT_CARD, LIABILITY_TYPE.STORE_CARD],
    ZEROVALID: [LIABILITY_TYPE.HELP_HECS_DEBT],
    HIDDEN: [LIABILITY_TYPE.CREDIT_CARD, LIABILITY_TYPE.STORE_CARD],
  },
  REPAYMENTS_FREQUENCY: {
    DISABLED: [LIABILITY_TYPE.CREDIT_CARD, LIABILITY_TYPE.STORE_CARD],
    OPTIONAL: [LIABILITY_TYPE.HELP_HECS_DEBT],
    HIDDEN: [LIABILITY_TYPE.CREDIT_CARD, LIABILITY_TYPE.STORE_CARD],
  },
  OPTIONS: {
    DISABLED: [LIABILITY_TYPE.HOME_LOAN],
  },
  NEW_LIMIT: {
    ENABLED: [...LIABILITIES_WITH_NEW_LIMIT],
  },
  REMAINING_TERM: {
    ENABLED: [
      LIABILITY_TYPE.HOME_LOAN,
      LIABILITY_TYPE.CAR_LOAN,
      LIABILITY_TYPE.PERSONAL_LOAN,
      LIABILITY_TYPE.LEASE,
      LIABILITY_TYPE.HIRE_PURCHASE,
      LIABILITY_TYPE.OTHER,
    ],
    HIDDEN: [
      LIABILITY_TYPE.LINE_OF_CREDIT,
      LIABILITY_TYPE.OVERDRAFT,
      LIABILITY_TYPE.CREDIT_CARD,
      LIABILITY_TYPE.STORE_CARD,
      LIABILITY_TYPE.TAX_DEBT,
      LIABILITY_TYPE.HELP_HECS_DEBT,
    ],
  },
  DESC: {
    ENABLED: [LIABILITY_TYPE.OTHER],
  },
};

export const AVERAGE_DAYS_OF_A_YEAR = 365.25;
